<template>
	<div class="modal-role">
		<span class="role-item" v-for="(item,index) in _newRoleList" :key="index" @click="activeRoleFn(item)" :class="{'active':baseCheckRoleId === item.id}">
			<img :src="item.img" />
			<em>{{item.rolename}}</em>
		</span>
		<el-row class="checked-btn"><el-button @click="saveDialog" type="primary" round>OK</el-button></el-row>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				role_list: new Array(),
				baseCheckRoleId: 0,
				activeDialog: new Object(),
				_newRoleList: new Array(),
			}
		},
		created() {
			this.initRoleList()
		},
		computed: {
			roleDialog() {
				return this.$store.state.dialog.roleDialog
			},
			newRoleList() {
				return this.$store.state.roles.newRoleList
			}
		},
		methods: {
			initRoleList() {
				this._newRoleList = [...this.newRoleList]
				this._newRoleList = this._newRoleList.filter(item => {
					return item.id !== 0
				})
				this._newRoleList.forEach(item => {
					if (item.sex === 0) {
						item.img = require(`../../assets/roles/bg_avatar_female_${item.icon}.png`)
					} else {
						item.img = require(`../../assets/roles/bg_avatar_male_${item.icon}.png`)
					}
				})
				this.baseCheckRoleId = this.roleDialog.role
			},
			saveDialog() {
				let activeRole = this._newRoleList.find(item => {
					return item.id === this.baseCheckRoleId
				})
				this.roleDialog.role = activeRole.id
				this.roleDialog.roleImage = activeRole.icon
				this.roleDialog.roleSex = activeRole.sex
				this.roleDialog.rolename = activeRole.rolename
				this.roleDialog.main = activeRole.main
				this.$store.dispatch('dialog/updateDialog',this.roleDialog)
			},
			activeRoleFn(item) {
				this.baseCheckRoleId = item.id
			}
		}
	}
	
</script>

<style lang="scss">
	.modal-role {
		span.role-item {
			margin: 0 2px 10px;
			text-align: center;
			width: 50px;
			display: inline-block;
			&.active {
				img {
					border-color: #fa4863;
				}
				color: #fa4863;
			}	
			img {
				height: 45px;
				width: 45px;
				border:1px solid #eaeaea;
				border-radius: 50px;
			}
			em {
				display: inline-block;
				width: 100%;
				font-size: 10px;
				height: 20px;
				overflow: hidden;
			}
		}
		.checked-btn {
			margin: 20px 0 0;
			display: flex;
			justify-content: center;    
		}
	}
</style>
